(function (global) {
    "use strict";

    var TEMPERAMENT_KEYS = [
        "easy_explorer",
        "resilient_adapter",
        "careful_observer",
        "intense_feeler",
    ];

    var POSITIVE_CLUSTER = {
        easy_explorer: true,
        resilient_adapter: true,
    };

    function emptyScores() {
        var s = {};
        TEMPERAMENT_KEYS.forEach(function (k) {
            s[k] = 0;
        });
        return s;
    }

    function addBucket(target, bucket) {
        if (!bucket || typeof target[bucket] !== "number") return;
        target[bucket] += 1;
    }

    function pickWinner(scores) {
        var winner = TEMPERAMENT_KEYS[0];
        var max = -1;
        TEMPERAMENT_KEYS.forEach(function (key) {
            if ((scores[key] || 0) > max) {
                max = scores[key];
                winner = key;
            }
        });
        return winner;
    }

    function getCluster(bucket) {
        return POSITIVE_CLUSTER[bucket] ? "positive" : "attention";
    }

    function escapeHtml(value) {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    function QuizEngine(sectionId, quizData, resultData, options) {
        this.sectionId = sectionId;
        this.quizData = quizData;
        this.resultData = resultData;
        this.options = options || {};
        this.state = {
            path: null,
            questionIndex: 0,
            answers: [],
            screen: "branch",
            pendingDual: { ayah: null, bunda: null },
        };
    }

    QuizEngine.prototype.reset = function () {
        this.state = {
            path: null,
            questionIndex: 0,
            answers: [],
            screen: "branch",
            pendingDual: { ayah: null, bunda: null },
        };
    };

    QuizEngine.prototype.selectPath = function (pathId) {
        if (!this.quizData.paths[pathId]) return;
        this.state.path = pathId;
        this.state.questionIndex = 0;
        this.state.answers = [];
        this.state.pendingDual = { ayah: null, bunda: null };
        this.state.screen = "question";
    };

    QuizEngine.prototype.getPath = function () {
        if (!this.state.path) return null;
        return this.quizData.paths[this.state.path];
    };

    QuizEngine.prototype.getCurrentQuestion = function () {
        var path = this.getPath();
        if (!path) return null;
        return path.questions[this.state.questionIndex] || null;
    };

    QuizEngine.prototype.getTotalQuestions = function () {
        var path = this.getPath();
        return path ? path.questions.length : 0;
    };

    QuizEngine.prototype.isDualColumn = function () {
        var path = this.getPath();
        return path && path.dualColumn === true;
    };

    QuizEngine.prototype.getSavedAnswer = function (questionIndex) {
        for (var i = 0; i < this.state.answers.length; i++) {
            if (this.state.answers[i].questionIndex === questionIndex) {
                return this.state.answers[i];
            }
        }
        return null;
    };

    QuizEngine.prototype.saveAnswer = function (entry) {
        var idx = entry.questionIndex;
        var existing = -1;
        for (var i = 0; i < this.state.answers.length; i++) {
            if (this.state.answers[i].questionIndex === idx) {
                existing = i;
                break;
            }
        }
        if (existing >= 0) {
            this.state.answers[existing] = entry;
            this.state.answers = this.state.answers.filter(function (a) {
                return a.questionIndex <= idx;
            });
        } else {
            this.state.answers.push(entry);
        }
    };

    QuizEngine.prototype.answerSingle = function (value) {
        var q = this.getCurrentQuestion();
        if (!q) return;
        this.saveAnswer({
            questionIndex: this.state.questionIndex,
            value: value,
        });
        this.advance();
    };

    QuizEngine.prototype.answerDual = function (ayahValue, bundaValue) {
        var q = this.getCurrentQuestion();
        if (!q || !ayahValue || !bundaValue) return;
        this.saveAnswer({
            questionIndex: this.state.questionIndex,
            ayah: ayahValue,
            bunda: bundaValue,
        });
        this.advance();
    };

    QuizEngine.prototype.goBack = function () {
        if (this.state.screen !== "question") return;

        if (this.state.questionIndex === 0) {
            this.state.path = null;
            this.state.answers = [];
            this.state.pendingDual = { ayah: null, bunda: null };
            this.state.screen = "branch";
            return;
        }

        this.state.questionIndex -= 1;
    };

    QuizEngine.prototype.advance = function () {
        var total = this.getTotalQuestions();
        if (this.state.questionIndex + 1 < total) {
            this.state.questionIndex += 1;
        } else {
            this.state.screen = "result";
        }
    };

    QuizEngine.prototype.calculateTemperament = function () {
        var path = this.getPath();
        if (!path) return "easy_explorer";

        if (path.dualColumn) {
            var ayahScore = emptyScores();
            var bundaScore = emptyScores();

            this.state.answers.forEach(function (ans) {
                var q = path.questions[ans.questionIndex];
                if (!q) return;
                if (q.options[ans.ayah])
                    addBucket(ayahScore, q.options[ans.ayah].bucket);
                if (q.options[ans.bunda])
                    addBucket(bundaScore, q.options[ans.bunda].bucket);
            });

            var ayahDominant = pickWinner(ayahScore);
            var bundaDominant = pickWinner(bundaScore);

            if (getCluster(ayahDominant) !== getCluster(bundaDominant)) {
                return "resilient_adapter";
            }

            var combinedScore = emptyScores();
            TEMPERAMENT_KEYS.forEach(function (key) {
                combinedScore[key] =
                    (ayahScore[key] || 0) * 0.5 + (bundaScore[key] || 0) * 0.5;
            });

            return pickWinner(combinedScore);
        }

        var scores = emptyScores();
        this.state.answers.forEach(function (ans) {
            var q = path.questions[ans.questionIndex];
            if (!q || !q.options[ans.value]) return;
            addBucket(scores, q.options[ans.value].bucket);
        });

        return pickWinner(scores);
    };

    QuizEngine.prototype.getQuizCopy = function () {
        return (this.quizData && this.quizData.copy) || {};
    };

    QuizEngine.prototype.getDisclaimer = function () {
        var copy = this.getQuizCopy();
        if (this.state.path === "C") {
            return (
                copy.disclaimerC ||
                "Hasil quiz ini bukan diagnosa klinis. Ini adalah panduan awal berdasarkan kecenderungan yang diturunkan secara ilmiah. Untuk evaluasi tumbuh kembang yang lebih mendalam, konsultasikan dengan dokter anak atau psikolog anak."
            );
        }
        return (
            copy.disclaimerAB ||
            "Hasil quiz ini bukan diagnosa klinis. Ini adalah panduan awal berdasarkan kecenderungan yang diturunkan secara ilmiah. Untuk evaluasi tumbuh kembang yang lebih mendalam, konsultasikan dengan dokter anak atau psikolog anak."
        );
    };

    QuizEngine.prototype.getResult = function () {
        var key = this.calculateTemperament();
        var meta = this.quizData.temperaments[key] || {};
        var data = this.resultData[key] || {};
        return {
            key: key,
            emoji: meta.emoji || "",
            title: data.title || key,
            desc: data.desc || "",
            tips: data.tips || "",
            productText: data.productText || "",
            image: data.image || "",
            idCollection: data.idCollection || "",
            disclaimer: this.getDisclaimer(),
        };
    };

    QuizEngine.prototype.buildResultProductsHtml = function (collectionId) {
        if (!collectionId) return "";

        var template = document.getElementById("qz-collection-" + collectionId);
        if (!template) {
            template = document.getElementById(
                "qz-collection-" + String(collectionId),
            );
        }
        if (!template || !template.content) return "";

        var wrapper = document.createElement("div");
        wrapper.appendChild(template.content.cloneNode(true));
        return wrapper.innerHTML;
    };

    QuizEngine.prototype.renderBranch = function (container) {
        var self = this;
        var paths = this.quizData.paths;
        var copy = this.getQuizCopy();

        container.innerHTML =
            '<div class="qz-branch">' +
            '<p class="qz-branch-intro">' +
            (copy.branchIntro ||
                "Pilih kondisi yang paling sesuai dengan si kecil:") +
            "</p>" +
            '<div class="qz-branch-grid">' +
            ["A", "B", "C"]
                .map(function (id) {
                    var p = paths[id];
                    var branch = (copy.branches && copy.branches[id]) || {};
                    var label = branch.label || p.label || id;
                    var description = branch.description || p.description || "";
                    return (
                        '<button type="button" class="qz-branch-card" data-path="' +
                        id +
                        '">' +
                        '<span class="qz-branch-card-title">' +
                        label +
                        "</span>" +
                        '<span class="qz-branch-card-desc">' +
                        description +
                        "</span>" +
                        "</button>"
                    );
                })
                .join("") +
            "</div>" +
            "</div>";
    };

    QuizEngine.prototype.renderQuestion = function (container) {
        var self = this;
        var path = this.getPath();
        var q = this.getCurrentQuestion();
        if (!path || !q) return;

        var idx = this.state.questionIndex;
        var total = this.getTotalQuestions();
        var pct = Math.round(((idx + 1) / total) * 100);
        var letters = ["A", "B", "C", "D", "E"];
        var saved = this.getSavedAnswer(idx);
        var T =
            (typeof window !== "undefined" && window.GentlyTranslations) || {};
        var backLabel =
            idx === 0
                ? T.quizChangePath || "← Change path"
                : T.quizBack || "← Back";

        var backBtnHtml =
            '<div class="qz-question-footer">' +
            '<button type="button" class="qz-back-btn" aria-label="' +
            (T.quizBack || "Back") +
            '">' +
            backLabel +
            "</button></div>";

        var progressHtml =
            '<div class="qz-progress-wrap">' +
            '<div class="qz-progress-text">' +
            (T.quizQuestionOf || "Question") +
            " " +
            (idx + 1) +
            " " +
            (T.quizOf || "of") +
            " " +
            total +
            "</div>" +
            '<div class="qz-progress-bar"><div class="qz-progress-fill" style="width:' +
            pct +
            '%"></div></div>' +
            "</div>";

        var microcopy = "";
        if (path.dualColumn && idx === 0) {
            microcopy =
                '<p class="qz-dual-microcopy">' +
                (this.getQuizCopy().microcopyC ||
                    "Isi kedua kolom ya — kalau Ayah tidak ada di sini, Bunda bisa jawabkan berdasarkan yang Bunda tahu tentang Ayah.") +
                "</p>";
        }

        if (path.dualColumn) {
            if (saved) {
                this.state.pendingDual = {
                    ayah: saved.ayah,
                    bunda: saved.bunda,
                };
            } else {
                this.state.pendingDual = { ayah: null, bunda: null };
            }
            var selectedAyah = this.state.pendingDual.ayah;
            var selectedBunda = this.state.pendingDual.bunda;

            function buildColumn(role, icon, selected) {
                return (
                    '<div class="qz-dual-col" data-role="' +
                    role +
                    '">' +
                    '<div class="qz-dual-col-header">' +
                    icon +
                    " " +
                    (role === "ayah"
                        ? T.quizDad || "Dad"
                        : T.quizMom || "Mom") +
                    "</div>" +
                    '<div class="qz-dual-options">' +
                    letters
                        .map(function (l) {
                            if (!q.options[l]) return "";
                            var sel = selected === l ? " is-selected" : "";
                            return (
                                '<button type="button" class="qz-dual-option' +
                                sel +
                                '" data-role="' +
                                role +
                                '" data-value="' +
                                l +
                                '">' +
                                "<strong>" +
                                l +
                                ".</strong> " +
                                q.options[l].label +
                                "</button>"
                            );
                        })
                        .join("") +
                    "</div>" +
                    "</div>"
                );
            }

            container.innerHTML =
                '<div class="qz-question-screen">' +
                progressHtml +
                microcopy +
                '<div class="qz-question">' +
                q.text +
                "</div>" +
                '<div class="qz-dual-grid">' +
                buildColumn("ayah", "👨", selectedAyah) +
                buildColumn("bunda", "👩", selectedBunda) +
                "</div>" +
                '<button type="button" class="qz-next-btn"' +
                (selectedAyah && selectedBunda ? "" : " disabled") +
                ">" +
                (T.quizNext || "Next") +
                "</button>" +
                backBtnHtml +
                "</div>";

            return;
        }

        var savedValue = saved ? saved.value : null;

        container.innerHTML =
            '<div class="qz-question-screen">' +
            progressHtml +
            '<div class="qz-question">' +
            q.text +
            "</div>" +
            '<div class="qz-options">' +
            letters
                .map(function (l) {
                    if (!q.options[l]) return "";
                    var sel =
                        savedValue === l ? " qz-option-btn--selected" : "";
                    return (
                        '<button type="button" class="qz-option-btn' +
                        sel +
                        '" data-value="' +
                        l +
                        '">' +
                        "<strong>" +
                        l +
                        ".</strong> " +
                        q.options[l].label +
                        "</button>"
                    );
                })
                .join("") +
            "</div>" +
            backBtnHtml +
            "</div>";
    };

    QuizEngine.prototype.renderResult = function (container, sectionId) {
        var result = this.getResult();

        if (typeof this.options.onResult === "function") {
            this.options.onResult(result);
        }

        container.innerHTML = "";

        var expandedEl = document.getElementById(
            "qz-result-expanded-" + sectionId,
        );
        if (expandedEl) {
            var tipsHtml = result.tips
                ? '<div class="qz-result-tips">' + result.tips + "</div>"
                : "";
            var disclaimerHtml = result.disclaimer
                ? '<div class="qz-result-disclaimer">' +
                  escapeHtml(result.disclaimer) +
                  "</div>"
                : "";
            var productHtml = result.productText
                ? '<div class="qz-result-product"><strong>Rekomendasi Produk Gently:</strong><p>' +
                  escapeHtml(result.productText) +
                  "</p></div>"
                : "";
            var productsGridHtml = this.buildResultProductsHtml(
                result.idCollection,
            );

            expandedEl.innerHTML =
                '<h3 class="qz-result-temperament-name" id="qz-result-heading-' +
                sectionId +
                '">' +
                result.emoji +
                " " +
                result.title +
                "</h3>" +
                tipsHtml +
                productsGridHtml;
        }

        this.toggleResultView(true);

        var charImg = document.getElementById(
            "qz-result-character-" + sectionId,
        );
        if (charImg && result.image) {
            charImg.crossOrigin = "anonymous";
            charImg.src = result.image;
        }

        var titleEl = document.getElementById("qz-result-title-" + sectionId);
        if (titleEl) titleEl.textContent = result.title;

        var descEl = document.getElementById("qz-result-desc-" + sectionId);
        if (descEl) descEl.innerHTML = result.desc || "";

        if (global.quizLastResult) {
            global.quizLastResult[sectionId] = {
                title: result.title,
                key: result.key,
            };
        }
    };

    QuizEngine.prototype.toggleResultView = function (showResult) {
        var resultModal = document.getElementById(
            "qz-result-" + this.sectionId,
        );
        if (showResult) {
            if (resultModal) {
                resultModal.hidden = false;
                resultModal.setAttribute("aria-hidden", "false");
            }
            document.body.classList.add("qz-result-modal-open");
        } else {
            if (resultModal) {
                resultModal.hidden = true;
                resultModal.setAttribute("aria-hidden", "true");
            }
            document.body.classList.remove("qz-result-modal-open");
            var expandedEl = document.getElementById(
                "qz-result-expanded-" + this.sectionId,
            );
            if (expandedEl) expandedEl.innerHTML = "";
        }
    };

    QuizEngine.prototype.render = function (container) {
        if (this.state.screen === "result") {
            this.renderResult(container, this.sectionId);
            return;
        }

        this.toggleResultView(false);

        if (this.state.screen === "branch") {
            this.renderBranch(container);
            return;
        }

        if (this.state.screen === "question") {
            this.renderQuestion(container);
        }
    };

    QuizEngine.prototype.retry = function (container) {
        this.reset();
        this.render(container);
        if (typeof this.options.onUpdate === "function")
            this.options.onUpdate();
    };

    function bindQuizContainerEvents(container, engine) {
        if (container.dataset.qzBound === "1") return;
        container.dataset.qzBound = "1";

        container.addEventListener("click", function (e) {
            var branchCard = e.target.closest(".qz-branch-card");
            if (branchCard && engine.state.screen === "branch") {
                engine.selectPath(branchCard.getAttribute("data-path"));
                engine.render(container);
                if (typeof engine.options.onUpdate === "function") {
                    engine.options.onUpdate();
                }
                return;
            }

            var backBtn = e.target.closest(".qz-back-btn");
            if (backBtn && engine.state.screen === "question") {
                engine.goBack();
                engine.render(container);
                if (typeof engine.options.onUpdate === "function") {
                    engine.options.onUpdate();
                }
                return;
            }

            var dualOpt = e.target.closest(".qz-dual-option");
            if (dualOpt && engine.state.screen === "question") {
                var role = dualOpt.getAttribute("data-role");
                var val = dualOpt.getAttribute("data-value");
                container
                    .querySelectorAll(
                        '.qz-dual-option[data-role="' + role + '"]',
                    )
                    .forEach(function (btn) {
                        btn.classList.remove("is-selected");
                    });
                dualOpt.classList.add("is-selected");
                if (role === "ayah") engine.state.pendingDual.ayah = val;
                else engine.state.pendingDual.bunda = val;
                var nextBtn = container.querySelector(".qz-next-btn");
                if (nextBtn) {
                    nextBtn.disabled = !(
                        engine.state.pendingDual.ayah &&
                        engine.state.pendingDual.bunda
                    );
                }
                return;
            }

            var nextBtn = e.target.closest(".qz-next-btn");
            if (
                nextBtn &&
                !nextBtn.disabled &&
                engine.state.screen === "question"
            ) {
                var ayah = engine.state.pendingDual.ayah;
                var bunda = engine.state.pendingDual.bunda;
                if (ayah && bunda) {
                    engine.answerDual(ayah, bunda);
                    engine.state.pendingDual = { ayah: null, bunda: null };
                    engine.render(container);
                    if (typeof engine.options.onUpdate === "function") {
                        engine.options.onUpdate();
                    }
                }
                return;
            }

            var optionBtn = e.target.closest(".qz-option-btn");
            if (optionBtn && engine.state.screen === "question") {
                engine.answerSingle(optionBtn.getAttribute("data-value"));
                engine.render(container);
                if (typeof engine.options.onUpdate === "function") {
                    engine.options.onUpdate();
                }
            }
        });
    }

    function applyQuizUiFromData(sectionId, quizData) {
        var copy = (quizData && quizData.copy) || {};
        var modal = document.getElementById("qz-result-" + sectionId);
        if (!modal) return;

        var bgImg = modal.querySelector(".qz-result-bg-img");
        if (bgImg && copy.resultBg) {
            bgImg.src = copy.resultBg;
        }

        var layer2 = modal.querySelector(".qz-result-layer-2");
        if (layer2 && copy.resultLayer2) {
            layer2.src = copy.resultLayer2;
        }
    }

    function initQuizSection(config) {
        var sectionId = config.sectionId;
        var container = document.getElementById("qz-container-" + sectionId);
        if (!container) return null;

        var engine = new QuizEngine(
            sectionId,
            config.quizData,
            config.resultData,
            {
                onUpdate: config.onUpdate,
                onResult: config.onResult,
            },
        );

        if (!global.quizEngines) global.quizEngines = {};
        global.quizEngines[sectionId] = engine;

        applyQuizUiFromData(sectionId, config.quizData);
        bindQuizContainerEvents(container, engine);
        engine.render(container);

        function dismissResultModal() {
            engine.toggleResultView(false);
            engine.retry(container);
        }

        var retryBtn = document.getElementById("qz-retry-btn-" + sectionId);
        if (retryBtn) {
            retryBtn.addEventListener("click", dismissResultModal);
        }

        var resultModal = document.getElementById("qz-result-" + sectionId);
        var resultCloseBtn = document.getElementById(
            "qz-result-close-" + sectionId,
        );
        var resultOverlay = resultModal
            ? resultModal.querySelector(".qz-result-modal-overlay")
            : null;

        if (resultCloseBtn) {
            resultCloseBtn.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                dismissResultModal();
            });
        }

        if (resultOverlay) {
            resultOverlay.addEventListener("click", dismissResultModal);
        }

        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && resultModal && !resultModal.hidden) {
                dismissResultModal();
            }
        });

        return engine;
    }

    global.QuizEngine = QuizEngine;
    global.initQuizSection = initQuizSection;
})(window);
